export default function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isRegExp.js
// module id = 2607
// module chunks = 1